/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { PropsWithChildren } from "react";
import ReactImageFallback from "react-image-fallback";

type ImgProps = PropsWithChildren<{
  src: string;
  className?: string;
  imageWidth?: number;
  imageHeight?: number;
  title?: string;
}>;

export function Img({
  src,
  className,
  imageWidth,
  imageHeight,
  title,
}: ImgProps) {
  return (
    <ReactImageFallback
      alt={`Image not found`}
      src={src}
      width={imageWidth || undefined}
      height={imageHeight || undefined}
      className={className}
      title={title}
      fallbackImage={require("../../../resources/images/fallback.jpg")}
    />
  );
}
